import { useState } from "react";
import { ArrowUpRight, Upload } from "lucide-react";
import { readFileAsDataURL } from "../lib/api";

export default function BasicForm({ fields, initial = {}, onSubmit, onClose, submit = "Save record" }) {
  const [form, setForm] = useState(() => {
    const base = Object.fromEntries(fields.map((f) => [f.key, f.default ?? ""]));
    return { ...base, ...initial };
  });
  const [busy, setBusy] = useState(false);

  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const handleFile = async (key, file) => {
    if (!file) return;
    const dataUrl = await readFileAsDataURL(file);
    update(`${key}_name`, file.name);
    update(`${key}_data`, dataUrl);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSubmit(form);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-grid">
        {fields.map((f) => (
          <label key={f.key} className={f.full ? "full" : ""}>
            {f.label}
            {f.type === "select" ? (
              <select data-testid={`${f.key}-select`} value={form[f.key] || ""} onChange={(e) => update(f.key, e.target.value)}>
                {(f.options || []).map((x) => (
                  <option key={typeof x === "string" ? x : x.value} value={typeof x === "string" ? x : x.value}>
                    {typeof x === "string" ? x : x.label}
                  </option>
                ))}
              </select>
            ) : f.type === "textarea" ? (
              <textarea data-testid={`${f.key}-input`} rows={3} value={form[f.key] || ""} onChange={(e) => update(f.key, e.target.value)} />
            ) : f.type === "file" ? (
              <div className="file-input">
                <Upload size={16} />
                <span>{form[`${f.key}_name`] || form[f.key] || "Attach PDF indent"}</span>
                <input data-testid={`${f.key}-input`} type="file" accept="application/pdf" onChange={(e) => handleFile(f.key, e.target.files?.[0])} />
              </div>
            ) : (
              <input data-testid={`${f.key}-input`} type={f.type || "text"} value={form[f.key] ?? ""} onChange={(e) => update(f.key, e.target.value)} required={f.required} />
            )}
            {f.hint && <small className="field-hint">{f.hint}</small>}
          </label>
        ))}
      </div>
      <div className="modal-actions">
        <button type="button" className="secondary" data-testid="form-cancel-button" onClick={onClose}>Cancel</button>
        <button className="primary" data-testid="form-submit-button" disabled={busy}>
          {busy ? "Saving…" : submit} <ArrowUpRight size={16} />
        </button>
      </div>
    </form>
  );
}
